export const type = [
  {
    type: 'EX',
    name: '视觉精细',
  },
  {
    type: 'ST',
    name: '视觉刺激',
  },
  {
    type: 'MFBF',
    name: '脱抑制',
  },
  {
    type: 'FU',
    name: '集合训练',
  },
  {
    type: 'DV',
    name: '散开训练',
  },
  {
    type: 'SV',
    name: '同时视',
  },
  {
    type: 'STE',
    name: '立体视',
  },
  {
    type: 'DR',
    name: '多人训练',
  },
  {
    type: 'ACC',
    name: '调节训练',
  },
  {
    type: 'MYO',
    name: '近视训练',
  },
  {
    type: 'EXAM',
    name: '检查',
  },
]
